export function mapAssistantReference(reference) {
  switch (reference.type) {
    case 'domains':
      return {
        domainReferences: reference
      };
    case 'assistant':
      return {
        assistantReference: reference
      };
    case 'unified-assistant':
      return {
        unifiedAssistantReference: reference
      };
    default:
      throw new Error(`unknown reference type: ${reference}`);
  }
}
//# sourceMappingURL=mapAssistantReference.js.map